import { Statistic } from "antd"
const { Countdown: AntdCountDown } = Statistic

const CountDown = props => {
  return <AntdCountDown {...props} />
}

export default CountDown
